import { render } from "./DriveFilesSubpage.vue?vue&type=template&id=610295e6&scoped=true&ts=true"
import script from "./DriveFilesSubpage.vue?vue&type=script&lang=ts"
export * from "./DriveFilesSubpage.vue?vue&type=script&lang=ts"

import "./DriveFilesSubpage.vue?vue&type=style&index=0&id=610295e6&scoped=true&lang=sass"

import exportComponent from "/home/casedrive/releases/front/108/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-610295e6"]])

export default __exports__